import { render, staticRenderFns } from "./passo2.vue?vue&type=template&id=39ed6fde&scoped=true&"
import script from "./passo2.vue?vue&type=script&lang=js&"
export * from "./passo2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39ed6fde",
  null
  
)

export default component.exports